import { render } from "./CustomInputText.vue?vue&type=template&id=ce3ae452&scoped=true"
import script from "./CustomInputText.vue?vue&type=script&lang=js"
export * from "./CustomInputText.vue?vue&type=script&lang=js"

import "./CustomInputText.vue?vue&type=style&index=0&id=ce3ae452&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce3ae452"]])

export default __exports__